import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import PrivateRoute from './components/auth/private_route';
import HomeScreen from './screens/home';
import LoginScreen from './screens/auth/login';
import ActivateScreen from './screens/auth/activate';
import ForgotPasswordScreen from './screens/auth/forgot_password';
import DashbordScreen from './screens/dashbord';

// Imports do Usuário Adm e Support
import UserNewScreen from './screens/user/new';
import UserEditScreen from './screens/user/edit';

// Imports do Usuário App
import AppIndexScreen from './screens/app/index';
import AppFindScreen from './screens/app/find';
import AppNewScreen from './screens/app/new';

// Imports do Usuário PDV
import PdvIndexScreen from './screens/pdv/index';
import PdvFindScreen from './screens/pdv/find';
import PdvNewScreen from './screens/pdv/new';

import NotificationsScreen from './screens/notifications';

import QuestionsScreen from './screens/questions';

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path='/' component={HomeScreen} />
        <Route exact path='/login' component={LoginScreen} />
        <Route exact path='/activate' component={ActivateScreen} />
        <Route exact path='/forgot-password' component={ForgotPasswordScreen} />

        <PrivateRoute exact path='/dashbord' component={DashbordScreen} />
        <PrivateRoute exact path='/user/new' component={UserNewScreen} />
        <PrivateRoute exact path='/user/edit' component={UserEditScreen} />

        {/*Rotas do Usuário App*/}
        <PrivateRoute exact path='/app' component={AppIndexScreen} />
        <PrivateRoute exact path='/app/find' component={AppFindScreen} />
        <PrivateRoute exact path='/app/new' component={AppNewScreen} />
        <PrivateRoute exact path='/app/new/:cpf' component={AppNewScreen} />

        {/*Rotas do Usuário PDV*/}
        <PrivateRoute exact path='/pdv' component={PdvIndexScreen} />
        <PrivateRoute exact path='/pdv/find' component={PdvFindScreen} />
        <PrivateRoute exact path='/pdv/new' component={PdvNewScreen} />
        <PrivateRoute exact path='/pdv/new/:cpf' component={PdvNewScreen} />

        <PrivateRoute exact path='/notifications' component={NotificationsScreen} />

        <PrivateRoute exact path='/questions' component={QuestionsScreen} />
      </Switch>
    </BrowserRouter>
  )
}

export default Routes;

